/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ContactService } from './services/contact.service';
import { AdminService } from './services/admin.service';
import { FeedbackService } from './services/feedback.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ContactService,
    AdminService,
    FeedbackService,
    ApiConfiguration
  ],
})
export class ContactApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ContactApiModule> {
    return {
      ngModule: ContactApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ContactApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ContactApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
